import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { AccountConnection, QueryAccountsArgs } from '../gql-types.generated';
import { getStandardHeaders } from '../util/StandardRequestHeaders';

// eslint-disable-next-line @typescript-eslint/naming-convention
const QUERY_ALL_TENANT_ACCOUNTS = gql`
  query allTenantAccounts(
    $first: Int
    $after: String
    $queryString: String
    $status: [CompanyVerificationStatus!]
    $orderBy: AccountOrder
  ) {
    accounts(first: $first, after: $after, queryString: $queryString, status: $status, orderBy: $orderBy) {
      nodes {
        id
        owner {
          tenantId
        }
        company {
          name
          verification {
            status
          }
        }
        businessProfile {
          name
        }
        payfac {
          ids {
            resourceId
            resourceType
          }
        }
        payFacType
        createdAt
        tosAcceptance {
          date
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
      totalCount
    }
  }
`;

export const queryAllTenantAccounts = async (
  client: ApolloClient<NormalizedCacheObject>,
  args?: Pick<QueryAccountsArgs, 'first' | 'after' | 'queryString' | 'status' | 'orderBy'>,
): Promise<AccountConnection | undefined> => {
  const headers = await getStandardHeaders(true);
  const { data, errors } = await client.query<{ accounts: AccountConnection }>({
    query: QUERY_ALL_TENANT_ACCOUNTS,
    variables: {
      first: args?.first ?? 25,
      after: args?.after,
      queryString: args?.queryString,
      status: args?.status,
      orderBy: args?.orderBy,
    },
    context: { headers },
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  });

  if (errors && errors.length > 0) {
    errors.forEach(error => console.warn('[allTenantAccounts]', error.message));
    if (!data?.accounts) {
      throw new Error('An error has occurred during the query.');
    }
  }

  return data?.accounts;
};
